function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Asset_6",
  "data-name": "Asset 6",
  transform: "translate(0.03 0.003)"
}, React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1",
  transform: "translate(-0.03 -0.003)"
}, React.createElement("path", {
  id: "Path_5204",
  "data-name": "Path 5204",
  d: "M58.091,43.266c0,.167,0,.334-.013.5a9.831,9.831,0,0,1-3.207,6.712c-.1.089-.2.178-.306.264a9.666,9.666,0,0,1-4.882,2.129,10.092,10.092,0,0,1-1.279.083h-.016a9.682,9.682,0,0,1-8.144-4.465.029.029,0,0,0-.006-.01l-.445-.765-2.375-4.121a9.684,9.684,0,0,0-16.782,0l-2.375,4.121-.445.765-.007.01a9.682,9.682,0,0,1-8.144,4.465H9.652a10.081,10.081,0,0,1-1.279-.083,9.655,9.655,0,0,1-4.509-1.837c-.1-.076-.2-.156-.3-.237a9.793,9.793,0,0,1-3.59-7.837v-.02c0-.1.01-.2.016-.294a9.645,9.645,0,0,1,1.289-4.216l.264-.457L20.64,4.847a9.685,9.685,0,0,1,16.782,0L56.531,37.994l.25.434a9.745,9.745,0,0,1,1.187,3.306c.016.1.031.2.044.3v.006q.018.151.033.3c.008.073.013.146.018.222s.011.14.013.211.008.165.009.248S58.091,43.182,58.091,43.266Z",
  transform: "translate(0.03 0.003)"
})));

var SvgAbel = function SvgAbel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 58.121,
    height: 52.955,
    viewBox: "0 0 58.121 52.955",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAbel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ABEL.b90638ff.svg";
export { ForwardRef as ReactComponent };